module.exports = __webpack_public_path__ + "static/media/RR_A_13.c4a7e37a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/clothes/accessorius/RR_A_13.png
// module id = 197
// module chunks = 0